// extracted by mini-css-extract-plugin
export default {"errorContainer":"Errors_errorContainer__IjxbX","errorContainerNoBorder":"Errors_errorContainerNoBorder__kGTVA","error":"Errors_error__wjFUM"};